var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file 日期选择 week table header
 * @author (zhanghao14)
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash-es';

import classnames from 'classnames';
import moment from 'moment';

import { noop, classPrefix } from '../../common/util';

var getShowRange = function getShowRange(dateVal) {
    if (!dateVal) {
        return {};
    }
    var month = dateVal.clone();
    var firstDay = month.clone().startOf('month');
    var lastMonthDiffDay = +firstDay.format('d');
    firstDay.subtract(lastMonthDiffDay, 'days');
    var lastDay = month.clone().endOf('month');
    var nextMonthDiffDay = +lastDay.format('d') % 7;
    lastDay.add(nextMonthDiffDay, 'days');
    return {
        firstDay: firstDay,
        lastDay: lastDay
    };
};
var FORMAT = 'YYYY-MM-DD';
var isActiveWeek = function isActiveWeek(currentDate, currentWeek) {
    return currentWeek && currentDate.week() === currentWeek.week();
};
var isSelectedDay = function isSelectedDay(date, currentDay) {
    if (!currentDay) {
        return false;
    }
    if (_.isArray(currentDay)) {
        for (var i = 0; i < currentDay.length; i++) {
            var current = currentDay[i];
            if (current && date.format(FORMAT) === current.format(FORMAT)) {
                return true;
            }
        }
        return false;
    }
    return date.format(FORMAT) === currentDay.format(FORMAT);
};
var isToday = function isToday(currentDate) {
    return currentDate.format(FORMAT) === moment().format(FORMAT);
};
var isLastMonth = function isLastMonth(currentDate, firstDayOfMonth) {
    return firstDayOfMonth && currentDate.month() < firstDayOfMonth.month();
};
var isNextMonth = function isNextMonth(currentDate, lastDayofMonth) {
    return lastDayofMonth && currentDate.month() > lastDayofMonth.month();
};
var isSaturday = function isSaturday(currentDate) {
    return currentDate.format('d') === '6';
};
var isSunday = function isSunday(currentDate) {
    return currentDate.format('d') === '0';
};
var getDateStyleProps = function getDateStyleProps(day, currentDay) {
    return {
        isLastMonth: isLastMonth(day, currentDay),
        isNextMonth: isNextMonth(day, currentDay),
        isSelectedDay: isSelectedDay(day, currentDay),
        isToday: isToday(day)
    };
};

var weekSelected = function weekSelected(date, selectValue) {
    if (selectValue) {
        return date.week() === selectValue.week() && date.weekYear() === selectValue.weekYear();
    }
    return false;
};

var WeekBody = function (_Component) {
    _inherits(WeekBody, _Component);

    function WeekBody() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, WeekBody);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WeekBody.__proto__ || Object.getPrototypeOf(WeekBody)).call.apply(_ref, [this].concat(args))), _this), _this.onMouseEnter = function (date, e) {
            _this.props.onMouseEnterDate && _this.props.onMouseEnterDate(date, e);
        }, _this.onMouseLeave = function (date, e) {
            _this.props.onMouseLeaveDate && _this.props.onMouseLeaveDate(date, e);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WeekBody, [{
        key: 'onClick',
        value: function onClick(date) {
            this.props.onChange && this.props.onChange(date);
        }
    }, {
        key: 'renderMonth',
        value: function renderMonth(firstDay) {
            var res = [];
            if (!firstDay) {
                return null;
            }
            var day = firstDay.clone();
            var rows = this.props.rows;
            for (var i = 0; i < rows; i++) {
                res.push(this.renderWeek(day, firstDay));
                day.add(1, 'weeks');
            }
            return res;
        }
    }, {
        key: 'renderWeek',
        value: function renderWeek(firstDayOfWeek) {
            var _classnames;

            if (!firstDayOfWeek) {
                return null;
            }
            var _props = this.props,
                prefixCls = _props.prefixCls,
                value = _props.value,
                weekPicker = _props.weekPicker;

            var day = firstDayOfWeek.clone();
            var res = [];
            for (var i = 0; i < this.props.columns; i++) {
                res.push(this.renderDay(day));
                day.add(1, 'days');
            }
            var isActive = isActiveWeek(firstDayOfWeek, value);
            var prefix = prefixCls + '-calendar-table-week';
            var weekClassName = classnames((_classnames = {}, _defineProperty(_classnames, prefix, true), _defineProperty(_classnames, prefix + '-active', isActive), _defineProperty(_classnames, 'week-picker', weekPicker), _classnames));
            var trProps = {
                className: weekClassName,
                key: day.week()
            };
            return React.createElement(
                'tr',
                trProps,
                res
            );
        }
    }, {
        key: 'renderDay',
        value: function renderDay(date) {
            var _classnames2;

            if (!date) {
                return null;
            }
            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                value = _props2.value,
                disableDate = _props2.disableDate,
                format = _props2.format,
                selectValue = _props2.selectValue,
                betweenSelected = _props2.betweenSelected,
                weekPicker = _props2.weekPicker;

            var _getDateStyleProps = getDateStyleProps(date, value),
                isLastMonth = _getDateStyleProps.isLastMonth,
                isNextMonth = _getDateStyleProps.isNextMonth,
                isToday = _getDateStyleProps.isToday;

            var nextDay = date.clone().add(1, 'days');
            var lastDay = date.clone().add(-1, 'days');
            var isDisabled = disableDate(date);
            var isLastdayDisabled = disableDate(lastDay);
            var isNextDayDisabled = disableDate(nextDay);
            var prefix = prefixCls + '-calendar-table-date';
            var dateClassName = classnames((_classnames2 = {}, _defineProperty(_classnames2, prefix, true), _defineProperty(_classnames2, prefix + '-last-month', isLastMonth), _defineProperty(_classnames2, prefix + '-next-month', isNextMonth), _defineProperty(_classnames2, prefix + '-disabled', isDisabled), _defineProperty(_classnames2, 'disabled-left', !isSunday(date) && isLastdayDisabled), _defineProperty(_classnames2, 'disabled-right', !isSaturday(date) && isNextDayDisabled), _defineProperty(_classnames2, 'disabled-lastday-between-selected', isDisabled && !isSunday(date) && !disableDate(lastDay) && !getDateStyleProps(lastDay, value).isLastMonth && !getDateStyleProps(lastDay, value).isNextMonth && betweenSelected && betweenSelected(date) && (betweenSelected(lastDay) || isSelectedDay(lastDay, selectValue))), _defineProperty(_classnames2, 'disabled-nextday-between-selected', isDisabled && !isSaturday(date) && !disableDate(nextDay) && !getDateStyleProps(nextDay, value).isLastMonth && !getDateStyleProps(nextDay, value).isNextMonth && betweenSelected && betweenSelected(date) && (betweenSelected(nextDay) || isSelectedDay(nextDay, selectValue))), _defineProperty(_classnames2, prefix + '-disabled-selected', isDisabled && !weekPicker // 周选择器模式，无单日选择态
            && isSelectedDay(date, selectValue)), _defineProperty(_classnames2, prefix + '-disabled-today', isDisabled && isToday), _defineProperty(_classnames2, prefix + '-selected', !isDisabled && !isLastMonth && !isNextMonth && !weekPicker // 周选择器模式，无单日选择态
            && isSelectedDay(date, selectValue)), _defineProperty(_classnames2, prefix + '-today', isToday && !isDisabled), _defineProperty(_classnames2, prefix + '-between-selected', !isDisabled && (weekPicker || !isLastMonth) // 周选择器模式，上下月的日期的hover态
            && (weekPicker || !isNextMonth) && betweenSelected && betweenSelected(date)), _defineProperty(_classnames2, prefix + '-next-between-selected', !isDisabled && !isSaturday(date) && !getDateStyleProps(nextDay, value).isLastMonth && !getDateStyleProps(nextDay, value).isNextMonth && isSelectedDay(date, selectValue) && betweenSelected && (betweenSelected(nextDay) || isSelectedDay(nextDay, selectValue))), _defineProperty(_classnames2, prefix + '-prev-between-selected', !isDisabled && !isSunday(date) && !getDateStyleProps(lastDay, value).isLastMonth && !getDateStyleProps(lastDay, value).isNextMonth && isSelectedDay(date, selectValue) && betweenSelected && (betweenSelected(lastDay) || isSelectedDay(lastDay, selectValue))), _defineProperty(_classnames2, prefix + '-disabled-first-of-row', isDisabled && (isSunday(date) || !isLastdayDisabled)), _defineProperty(_classnames2, prefix + '-disabled-last-of-row', isDisabled && (isSaturday(date) || !isNextDayDisabled)), _defineProperty(_classnames2, 'first-of-row', isSunday(date)), _defineProperty(_classnames2, 'last-of-row', isSaturday(date)), _defineProperty(_classnames2, 'hover-end-left', !isDisabled && !isLastMonth && !isNextMonth && betweenSelected && betweenSelected(date) && !betweenSelected(lastDay) && !isSelectedDay(lastDay, selectValue)), _defineProperty(_classnames2, 'hover-end-right', !isDisabled && !isLastMonth && !isNextMonth && betweenSelected && betweenSelected(date) && !betweenSelected(nextDay) && !isSelectedDay(nextDay, selectValue)), _defineProperty(_classnames2, prefix + '-week-selected', weekPicker && weekSelected(date, selectValue)), _defineProperty(_classnames2, 'has-active', !weekPicker), _classnames2));
            var dateClone = date.clone();
            var tdProps = {
                className: dateClassName,
                key: date.dayOfYear(),
                title: !weekPicker ? date.format(format) : date.clone().endOf('week').format(format),
                onClick: isDisabled ? noop : this.onClick.bind(this, dateClone),
                onMouseEnter: isDisabled ? noop : this.onMouseEnter.bind(this, dateClone),
                onMouseLeave: isDisabled ? noop : this.onMouseLeave.bind(this, dateClone)
            };
            var divClassName = classnames(_defineProperty({}, prefix + '-cell', true));
            var divProps = {
                className: divClassName
            };
            return React.createElement(
                'td',
                tdProps,
                React.createElement(
                    'div',
                    divProps,
                    React.createElement(
                        'span',
                        null,
                        date.format('DD')
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var firstDay = getShowRange(this.props.value || moment()).firstDay;

            var className = classnames(_defineProperty({}, this.props.prefixCls + '-calendar-table-body', true));
            var containerProps = {
                className: className
            };
            return React.createElement(
                'tbody',
                containerProps,
                this.renderMonth(firstDay)
            );
        }
    }]);

    return WeekBody;
}(Component);

export default WeekBody;


WeekBody.defaultProps = {
    // base
    skin: '',
    className: '',
    style: {},
    // self
    value: null,
    rows: 6,
    columns: 7,
    prefixCls: classPrefix + '-date-picker',
    format: '',
    disableDate: noop,
    onChange: noop
};

WeekBody.propTypes = {
    skin: PropTypes.string,
    className: PropTypes.string,
    format: PropTypes.string.isRequired,
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    value: PropTypes.object,
    rows: PropTypes.number,
    columns: PropTypes.number,
    disableDate: PropTypes.func,
    onChange: PropTypes.func,
    selectValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    betweenSelected: PropTypes.func,
    onMouseEnterDate: PropTypes.func,
    onMouseLeaveDate: PropTypes.func,
    weekPicker: PropTypes.bool
};